<template>

    <b-row>

        <b-col sm="12">

            <b-tabs pills>

                <b-tab title="Settings" active class="mt-4">

                    <b-card :header="title"
                        header-bg-variant="info"
                        header-text-variant="white"
                        >
                        <div v-if="carrier.id" class="d-flex">
                            <h4 class="ml-auto larger">
                                Carrier Status:
                                <span v-if="active" class="text-info">Active</span>
                                <span v-else class="text-info">Inactive</span>
                            </h4>
                        </div>
                        <form @submit.prevent="submit()" @keydown="form.clearError($event.target.name)" autocomplete="off">
                            <b-row>
                                <b-col lg="6">
                                    <b-form-group label="Name *" label-for="name">
                                        <b-form-input
                                            name="name"
                                            type="text"
                                            v-model="form.name"
                                            required
                                        >
                                        </b-form-input>
                                        <input-help :form="form" field="name" text="The name of the Carrier."></input-help>
                                    </b-form-group>
                                    <b-form-group label="Short Name *" label-for="initials">
                                        <b-form-input
                                            name="initials"
                                            type="text"
                                            v-model="form.initials"
                                            required
                                        >
                                        </b-form-input>
                                        <input-help :form="form" field="initials" text="The Carrier's shorthand name or initials."></input-help>
                                    </b-form-group>


                                    <b-form-group label="Import Name Match" label-for="import_match">
                                        <b-form-input
                                            id="import_match"
                                            name="import_match"
                                            type="text"
                                            v-model="form.import_match"
                                        >
                                        </b-form-input>
                                        <input-help :form="form" field="import_match" text="The name to match exactly on imports."></input-help>
                                    </b-form-group>


                                    <b-form-group label="Parent Carrier/Report Filter Carrier" label-for="parent_carrier_id">
                                        <carrier-parents-dropdown v-model="form.parent_carrier_id"></carrier-parents-dropdown>
                                        <input-help :form="form" field="parent_carrier_id" text=""></input-help>
                                    </b-form-group>

                                    <b-form-group label="Customer Service Number *" label-for="phone">
                                        <b-form-input
                                            id="phone"
                                            name="phone"
                                            type="text"
                                            v-model="form.phone"
                                            required
                                        >
                                        </b-form-input>
                                        <input-help :form="form" field="phone" text="The Carrier's customer service phone number."></input-help>
                                    </b-form-group>

                                    <b-form-group label="Enable User Data Pull" label-for="enabled_user_data_pull">

                                        <b-select name="enabled_user_data_pull" id="enabled_user_data_pull" v-model="form.enabled_user_data_pull">
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                        </b-select>
                                        <input-help :form="form" field="enabled_user_data_pull" text="Providers and Claimants can download their visit history and invoices ( claimants only )"></input-help>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6">

                                    <b-form-group label="Carrier Logo" label-for="logo_filename">

                                        <business-carrier-logo-editor v-model="form.logo_filename" :url="carrier.logo_url"></business-carrier-logo-editor>
                                        <input-help :form="form" field="logo_filename" text="Logo will replace the CareExchange logo on the invoice"></input-help>
                                    </b-form-group>
                                    <b-form-group label="Is a TPA Client" label-for="is_tpa">

                                        <b-select name="is_tpa" id="is_tpa" v-model="form.is_tpa">
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                        </b-select>
                                        <input-help :form="form" field="is_tpa" text="Mark this block as Third-Party-Administrator, meaning that Careexchange manages their invoices"></input-help>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="12">
                                <p class="h5 mt-4">Visit Settings</p>
                                <hr>
                              </b-col>
                              <b-col lg="6">
                                <b-form-group label="EVV Radius (Meters)" label-for="evv_radius">

                                  <b-form-input
                                      v-model="form.evv_radius"
                                      id="evv_radius"
                                      name="evv_radius"
                                      type="number"
                                      step="1"
                                  ></b-form-input>
                                  <input-help :form="form" field="evv_radius" text="The distance in meters that the provider can be from the claimant's address."></input-help>
                                </b-form-group>
                              </b-col>
                              <b-col lg="6">
                                <b-form-group label="Enable `Has the client had any hospital stays since your last visit?` upon clock-out (EVV and TVV)" label-for="hospital_stays_enabled">
                                    <b-form-radio
                                        name="hospital_stays_enabled"
                                        v-model="form.hospital_stays_enabled"
                                        @change="updateHospitalStayFlags($event)"
                                        value="0"
                                    > No/Disabled </b-form-radio>
                                    <b-form-radio
                                        name="hospital_stays_enabled"
                                        v-model="form.hospital_stays_enabled"
                                        @change="updateHospitalStayFlags($event)"
                                        value="1"
                                    > Yes/Enabled </b-form-radio>
                                </b-form-group>

                                <b-col lg="12" v-show="form.hospital_stays_enabled == 1">
                                    <b-form-group label="Enable Enhanced hospital checkout flow (require hospital checkout question and start / end dates of visit)" label-for="hospital_stays_enhanced_flow">
                                        <b-form-radio
                                            name="hospital_stays_enhanced_flow"
                                            v-model="form.hospital_stays_enhanced_flow"
                                            value="0"
                                        > No/Disabled </b-form-radio>
                                        <b-form-radio
                                            name="hospital_stays_enhanced_flow"
                                            v-model="form.hospital_stays_enhanced_flow"
                                            value="1"
                                        > Yes/Enabled </b-form-radio>
                                    </b-form-group>
                                </b-col>
                              </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12">
                                    <p class="h5 mt-4">Enrollment Settings</p>
                                    <hr>
                                </b-col>
                                <b-col lg="6">
                                    <b-form-group label="Auto-enroll Claimants" label-for="auto_enroll_claimants">
                                        <b-select class="form-control" name="auto_enroll_claimants" id="auto_enroll_claimants" v-model="form.auto_enroll_claimants">
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                        </b-select>
                                        <input-help :form="form" field="auto_enroll_claimants" text="This will also add any un-enrolled providers to the DRC queue."></input-help>
                                    </b-form-group>
                                    <b-form-group label="Use Enrollment Queue" label-for="use_enrollment_queue">
                                        <b-select name="use_enrollment_queue" id="use_enrollment_queue" v-model="form.use_enrollment_queue">
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                        </b-select>
                                        <input-help :form="form" field="use_enrollment_queue" text="Use the DRC queue and auto-queue new claimants and providers."></input-help>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6">
                                    <div class="form-check">
                                        <b-form-checkbox name="remember" v-model="form.custom_enrollment_codes">Use Custom Enrollment Code</b-form-checkbox>
                                    </div>
                                    <b-form-group label="Claimant Enrollment Codes Template" label-for="client_enrollment_code">
                                        <b-form-input
                                            v-model="form.client_enrollment_code"
                                            id="client_enrollment_code"
                                            name="client_enrollment_code"
                                            type="text"
                                            :disabled="!form.custom_enrollment_codes"
                                        ></b-form-input>
                                        <input-help :form="form" field="client_enrollment_code" text="Template used to generate Claimant enrollment codes."></input-help>
                                        <small class="form-text text-muted">
                                            <span v-if="!checkIfCNAGroup">
                                                The following variables will auto-populate:<br />
                                                #POLICY_NUMBER# - The claimants policy number.<br />
                                            </span>                                            
                                            <span v-else-if="!checkIfCalPERS">
                                                The following variables will auto-populate:<br />
                                                #COVERAGE_ID_NUMBER# - The claimants Coverage Id Number.<br />
                                            </span>
                                            <span v-else>
                                                The following variables will auto-populate:<br />
                                                #CERTIFICATE_NUMBER# - The claimants Certificate Number.<br />
                                            </span>
                                        </small>
                                    </b-form-group>
                                    <b-form-group label="Provider Enrollment Codes Template" label-for="caregiver_enrollment_code">
                                        <b-form-input
                                            v-model="form.caregiver_enrollment_code"
                                            id="caregiver_enrollment_code"
                                            name="caregiver_enrollment_code"
                                            type="text"
                                            :disabled="!form.custom_enrollment_codes"
                                        ></b-form-input>
                                        <input-help :form="form" field="caregiver_enrollment_code" text="Template used to generate Provider enrollment codes."></input-help>
                                        <small class="form-text text-muted">
                                            <span>
                                                The following variables will auto-populate:<br />
                                                #PHONE# - The caregiver's phone number.<br />
                                            </span>
                                        </small>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12">
                                    <p class="h5 mt-4">Terms & Language</p>
                                    <hr>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Claimant Terms" label-for="terms_client">
                                        <b-textarea
                                            id="terms_client"
                                            name="terms_client"
                                            v-model="form.terms_client"
                                            rows="4"
                                            :disabled="true"
                                        ></b-textarea>
                                        <input-help :form="form" field="terms_client" text=""></input-help>
                                    </b-form-group>
                                    <b-form-group label="Warning Language" label-for="warning_language">
                                        <b-textarea
                                            id="warning_language"
                                            name="warning_language"
                                            v-model="form.warning_language"
                                            rows="4"
                                        ></b-textarea>
                                        <input-help :form="form" field="warning_language" text=""></input-help>
                                    </b-form-group>
                                </b-col>
                                <b-col md="6">
                                    <b-form-group label="Independent Provider Terms" label-for="terms_caregiver">
                                        <b-textarea
                                            id="terms_caregiver"
                                            name="terms_caregiver"
                                            v-model="form.terms_caregiver"
                                            rows="4"
                                            :disabled="true"
                                        ></b-textarea>
                                        <input-help :form="form" field="terms_caregiver" text=""></input-help>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col lg="12">
                                    <p class="h5 mt-4">Invoice Transmission Settings</p>
                                    <hr>
                                </b-col>
                            </b-row>

                          <b-row>
                            <b-col lg="6">

                              <b-form-group label="Invoice Submission Based On Carrier Payment Day?" label-for="client_payment_day_enabled">
                                <b-form-radio v-model="form.client_payment_day_enabled" name="client_payment_day_enabled" value="0">No/Disabled</b-form-radio>
                                <b-form-radio v-model="form.client_payment_day_enabled" name="client_payment_day_enabled" value="1">Yes/Enabled</b-form-radio>
                                <div class="mt-2">
                                  <b-input type="number" min="-7" max="7" v-model="form.invoice_delta" name="invoice_delta"
                                           :required="form.client_payment_day_enabled == 1"
                                           :disabled="form.client_payment_day_enabled == 0"
                                  />
                                  <input-help :form="form" field="invoice_delta" text="CE will transmit invoices automatically this many days before/on/after the Carrier Payment Day at the Invoice Submission Time indicated to the right"></input-help>
                                </div>
                              </b-form-group>


                            </b-col>
                            <b-col lg="6">

                              <b-form-group label="Invoice Submission Time (Eastern Time)" label-for="invoice_submission_time"
                                v-show="hasPaymentDay"
                              >
                                <b-select class="form-control" :options="submissionTimes" v-model="form.invoice_submission_time" />
                              </b-form-group>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col lg="6">

                              <b-form-group
                                  label="Automatically Submit Invoices"
                                  label-for="invoice_auto_transmit"
                                  :disabled="form.batch_invoices == 1"
                              >

                                <b-form-radio v-model="form.invoice_auto_transmit" name="invoice_auto_transmit" value="0">No</b-form-radio>
                                <b-form-radio v-model="form.invoice_auto_transmit" name="invoice_auto_transmit" value="1">Yes</b-form-radio>

                                <input-help :form="form" field="invoice_auto_transmit" text="Automatic submission requires no Claimant interaction." />
                              </b-form-group>
                            </b-col>
                            <b-col lg="6">
                              <b-form-group
                                  label="Invoice Submission Day (Eastern Time)"
                                  label-for="invoice_submission_day"
                                  v-show="hasPaymentDay"
                              >
                                <b-select id="invoice_submission_day" :options="submissionDays" v-model="form.invoice_submission_day"/>
                              </b-form-group>
                            </b-col>
                          </b-row>
                            <b-row>
                                <b-col lg="6">
                                    <b-row>
                                        <b-col lg="12">
                                            <b-form-group label="Batch Submit Invoices" label-for="batch_invoices">
                                                <b-form-radio v-model="form.batch_invoices" name="batch_invoices" value="0">No</b-form-radio>
                                                <b-form-radio v-model="form.batch_invoices" name="batch_invoices" value="1">Yes</b-form-radio>
                                                <input-help :form="form" field="batch_invoices" text="Batch invoice submission as a single zip file." />
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="form.batch_invoices == 1">
                                        <b-col lg="6">
                                            <b-form-group
                                                label="Batch Schedule Weekdays"
                                                label-for="batch_schedule_days"
                                            >
                                                <b-form-checkbox
                                                    v-for="weekday in batch_schedule_days_list"
                                                    :key="weekday.value"
                                                    v-model="batch_schedule_days"
                                                    :value="weekday.value"
                                                    class="d-block my-2"
                                                >
                                                    {{ weekday.name }}
                                                </b-form-checkbox>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-form-group label="Batch Schedule Time (Eastern)" label-for="batch_schedule_time">
                                                <b-select id="batch_schedule_time" :options="batch_schedule_times_list" v-model="form.batch_schedule_time"/>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row v-if="form.batch_invoices == 1">
                                        <b-col lg="12">
                                            <b-form-group
                                                label="Send Batch Notification"
                                                label-for="batch_send_notification"
                                            >

                                                <b-form-radio v-model="form.batch_send_notification" name="batch_send_notification" value="0">No</b-form-radio>
                                                <b-form-radio v-model="form.batch_send_notification" name="batch_send_notification" value="1">Yes</b-form-radio>

                                                <input-help :form="form" field="batch_send_notification" text="Send notification (via email) with invoice list contained in batch, relies on email settings below" />
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col lg="6" v-if=" form.batch_invoices == 1 ">
                                    <b-row>
                                        <b-col lg="12">
                                            <b-form-group label="Invoice Batch Archive File Name" label-for="batch_filename">
                                                <b-form-input
                                                    v-model="form.batch_filename"
                                                    id="batch_filename"
                                                    name="batch_filename"
                                                    type="text"
                                                ></b-form-input>
                                                <input-help :form="form" field="batch_filename" text="Invoice archive file name (do not include extension)"></input-help>
                                                <input-template-vars :vars="invoice_batch_file_name_vars" />
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="12">
                                            <b-form-group
                                                label="Include File List in Invoice Batch Archive"
                                                label-for="batch_invoices_txt"
                                            >

                                                <b-form-radio v-model="form.batch_invoices_txt" name="batch_invoices_txt" value="0">No</b-form-radio>
                                                <b-form-radio v-model="form.batch_invoices_txt" name="batch_invoices_txt" value="1">Yes</b-form-radio>

                                                <input-help :form="form" field="batch_invoices_txt" text="Add file list TXT file inside of invoice batch archive file" />
                                            </b-form-group>
                                        </b-col>


                                        <b-col lg="12" v-if=" form.batch_invoices_txt == 1 ">
                                            <b-form-group label="File List Name" label-for="batch_txt_filename">
                                                <b-form-input
                                                    v-model="form.batch_txt_filename"
                                                    id="batch_txt_filename"
                                                    name="batch_txt_filename"
                                                    type="text"
                                                ></b-form-input>
                                                <input-help :form="form" field="batch_txt_filename" text="File list file name (do not include extension)"></input-help>
                                                <input-template-vars :vars="invoice_batch_file_name_vars" />
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col lg="6">

                                    <b-form-group label="Attachment Type" label-for="invoice_attachment_type">
                                        <b-select name="invoice_attachment_type" id="invoice_attachment_type" v-model="form.invoice_attachment_type">
                                            <option value="">-- Select a Attachment Type --</option>
                                            <option value="pdf">PDF</option>
                                            <option value="tiff">TIFF</option>
                                        </b-select>
                                        <input-help :form="form" field="invoice_attachment_type" text="The type of invoice file to attach."></input-help>
                                    </b-form-group>
                                    <b-form-group label="Transmission Type" label-for="invoice_transmission_type">
                                        <b-select class="form-control" name="invoice_transmission_type" id="invoice_transmission_type" v-model="form.invoice_transmission_type">
                                            <option value="">-- Select a Transmission Type --</option>
                                            <option value="ftp">FTP</option>
                                            <option value="email">Email</option>
                                        </b-select>
                                        <input-help :form="form" field="invoice_transmission_type" text=""></input-help>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6">
                                    <b-form-group label="Attachment Naming Convention" label-for="invoice_attachment_name">
                                        <b-form-input
                                            v-model="form.invoice_attachment_name"
                                            id="invoice_attachment_name"
                                            name="invoice_attachment_name"
                                            type="text"
                                            :disabled="form.batch_invoices == 0"
                                        ></b-form-input>
                                        <input-help :form="form" field="invoice_attachment_name" text="The naming convention of attached file"></input-help>
                                        <input-template-vars :vars="invoice_attachment_name_vars" />
                                    </b-form-group>

                                    <b-form-group label="Invoice Policy Name" label-for="invoice_policy_name">
                                      <b-select class="form-control" name="invoice_policy_name" id="invoice_policy_name" v-model="form.invoice_policy_name">
                                        <option value="Policy Number">Policy Number</option>
                                        <option value="Claim Number">Claim Number</option>
                                        <option value="Certificate Number">Certificate Number</option>
                                        <option value="Coverage Id Number">Coverage Id Number</option>
                                      </b-select>
                                        <input-help :form="form" field="invoice_policy_name" text="The text that appears for Policy or Claim Number"></input-help>
                                    </b-form-group>

                                  <b-form-group label="Invoice Policy Field" label-for="invoice_policy_field">
                                    <b-select class="form-control" name="invoice_policy_field" id="invoice_policy_field" v-model="form.invoice_policy_field">
                                      <option value="policy_number">Policy Number</option>
                                      <option value="claim_number">Claim Number</option>
                                      <option value="cert_no">Certificate Number</option>
                                      <option value="coverage_id_number">Coverage Id Number</option>
                                    </b-select>
                                    <input-help :form="form" field="invoice_policy_field" text="The text that appears for Policy or Claim Number"></input-help>
                                  </b-form-group>

                                  <b-form-group label="Invoices Require Approval" label-for="invoice_requires_approval">
                                    <b-form-radio v-model="form.invoice_requires_approval" name="invoice_requires_approval" value="0">No</b-form-radio>
                                    <b-form-radio v-model="form.invoice_requires_approval" name="invoice_requires_approval" value="1">Yes</b-form-radio>
                                  </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if=" form.invoice_transmission_type == 'ftp' || form.invoice_transmission_type == 'ftp_batch'">
                                <b-col lg="6">
                                    <b-form-group label="SFTP Host" label-for="invoice_ftp_host">
                                        <b-form-input
                                            v-model="form.invoice_ftp_host"
                                            id="invoice_ftp_host"
                                            name="invoice_ftp_host"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="invoice_ftp_host" text="SFTP host address. example: ftp.website.com"></input-help>
                                    </b-form-group>
                                    <b-form-group label="SFTP Directory" label-for="invoice_ftp_path">
                                        <b-form-input
                                            v-model="form.invoice_ftp_path"
                                            id="invoice_ftp_path"
                                            name="invoice_ftp_path"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="invoice_ftp_path" text="The path to place the uploaded files.  example: /path/to/save"></input-help>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6">
                                    <b-form-group label="SFTP Username" label-for="invoice_ftp_username">
                                        <b-form-input
                                            v-model="form.invoice_ftp_username"
                                            id="invoice_ftp_username"
                                            name="invoice_ftp_username"
                                            type="text"
                                            autocomplete="off"
                                        ></b-form-input>
                                        <input-help :form="form" field="invoice_ftp_username" text="Username for the FTP login credentials."></input-help>
                                    </b-form-group>
                                    <b-form-group label="SFTP Password" label-for="invoice_ftp_password">
                                        <b-form-input
                                            v-model="form.invoice_ftp_password"
                                            id="invoice_ftp_password"
                                            name="invoice_ftp_password"
                                            type="password"
                                            autocomplete="off"
                                        ></b-form-input>
                                        <input-help :form="form" field="invoice_ftp_password" text="Password for the FTP login credentials."></input-help>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="form.invoice_transmission_type == 'email' || (form.batch_invoices == 1 && form.batch_send_notification == 1)">
                                <b-col lg="6">
                                    <b-form-group label="Email To" label-for="invoice_email_to">
                                        <b-form-input
                                            v-model="form.invoice_email_to"
                                            id="invoice_email_to"
                                            name="invoice_email_to"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="invoice_email_to" text="The email address to send the email to."></input-help>
                                    </b-form-group>
                                    <b-form-group label="Email From" label-for="invoice_email_from">
                                        <b-form-input
                                            v-model="form.invoice_email_from"
                                            id="invoice_email_from"
                                            name="invoice_email_from"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="invoice_email_from" text="The email address to send from."></input-help>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6">
                                    <b-form-group label="Email Subject" label-for="invoice_email_subject">
                                        <b-form-input
                                            v-model="form.invoice_email_subject"
                                            id="invoice_email_subject"
                                            name="invoice_email_subject"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="invoice_email_subject" text="The subject of the email."></input-help>
                                        <input-template-vars :vars="email_subject_vars" />
                                    </b-form-group>
                                    <b-form-group label="Email Body" label-for="invoice_email_body">
                                        <b-textarea
                                            v-model="form.invoice_email_body"
                                            id="invoice_email_body"
                                            name="invoice_email_body"
                                            rows="4"
                                        ></b-textarea>
                                        <input-help :form="form" field="invoice_email_body" text="The body of the email. Markdown allowed"></input-help>
                                        <input-template-vars :vars="email_body_vars" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                          <b-row>

                            <b-col lg="6">
                              <b-form-group label="Invoice Color" label-for="grayscale_invoices">
                                  <b-form-radio v-model="form.grayscale_invoices" name="grayscale_invoices" value="0">Color</b-form-radio>
                                  <b-form-radio v-model="form.grayscale_invoices" name="grayscale_invoices" value="1">Black &amp; White</b-form-radio>
                              </b-form-group>
                            </b-col>
                            <b-col lg="6">
                            </b-col>
                          </b-row>
                            <b-row>
                                <b-col lg="12">
                                    <p class="h5 mt-4">Deactivation Transmission Settings</p>
                                    <hr>
                                </b-col>
                                <b-col lg="6">
                                    <b-form-group label="Attachment Type" label-for="decommission_attachment_type">
                                        <b-select class="form-control" name="decommission_attachment_type" id="decommission_attachment_type" v-model="form.decommission_attachment_type">
                                            <option value="">-- Select a Attachment Type --</option>
                                            <option value="pdf">PDF</option>
                                            <option value="tiff">TIFF</option>
                                        </b-select>
                                        <input-help :form="form" field="decommission_attachment_type" text="The type of invoice file to attach."></input-help>
                                    </b-form-group>
                                    <b-form-group label="Transmission Type" label-for="decommission_transmission_type">
                                        <b-select class="form-control" name="decommission_transmission_type" id="decommission_transmission_type" v-model="form.decommission_transmission_type">
                                            <option value="">-- Select a Transmission Type --</option>
                                            <option value="ftp">FTP</option>
                                            <option value="email">Email</option>
                                        </b-select>
                                        <input-help :form="form" field="decommission_transmission_type" text=""></input-help>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6">
                                    <b-form-group label="Attachment Naming Convention" label-for="decommission_attachment_name">
                                        <b-form-input
                                            v-model="form.decommission_attachment_name"
                                            id="decommission_attachment_name"
                                            name="decommission_attachment_name"
                                            type="text"
                                            disabled
                                        ></b-form-input>
                                        <input-help :form="form" field="decommission_attachment_name" text="The naming convention of the attached file."></input-help>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-if="form.decommission_transmission_type == 'ftp'">
                                <b-col lg="6">
                                    <b-form-group label="SFTP Host" label-for="decommission_ftp_host">
                                        <b-form-input
                                            v-model="form.decommission_ftp_host"
                                            id="decommission_ftp_host"
                                            name="decommission_ftp_host"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="decommission_ftp_host" text="SFTP host address.  example: ftp.website.com"></input-help>
                                    </b-form-group>
                                    <b-form-group label="SFTP Directory" label-for="decommission_ftp_path">
                                        <b-form-input
                                            v-model="form.decommission_ftp_path"
                                            id="decommission_ftp_path"
                                            name="decommission_ftp_path"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="decommission_ftp_path" text="The path to place the uploaded files.  example: /path/to/save"></input-help>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6">
                                    <b-form-group label="SFTP Username" label-for="decommission_ftp_username">
                                        <b-form-input
                                            v-model="form.decommission_ftp_username"
                                            id="decommission_ftp_username"
                                            name="decommission_ftp_username"
                                            type="text"
                                            autocomplete="off"
                                        ></b-form-input>
                                        <input-help :form="form" field="decommission_ftp_username" text="Username for the FTP login credentials."></input-help>
                                    </b-form-group>
                                    <b-form-group label="SFTP Password" label-for="decommission_ftp_password">
                                        <b-form-input
                                            v-model="form.decommission_ftp_password"
                                            id="decommission_ftp_password"
                                            name="decommission_ftp_password"
                                            type="password"
                                            autocomplete="off"
                                        ></b-form-input>
                                        <input-help :form="form" field="decommission_ftp_password" text="Password for the FTP login credentials."></input-help>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row v-else-if="form.decommission_transmission_type == 'email'">
                                <b-col lg="6">
                                    <b-form-group label="Email To" label-for="decommission_email_to">
                                        <b-form-input
                                            v-model="form.decommission_email_to"
                                            id="decommission_email_to"
                                            name="decommission_email_to"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="decommission_email_to" text="The email address to send the email to."></input-help>
                                    </b-form-group>
                                    <b-form-group label="Email From" label-for="decommission_email_from">
                                        <b-form-input
                                            v-model="form.decommission_email_from"
                                            id="decommission_email_from"
                                            name="decommission_email_from"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="decommission_email_from" text="The email address to send from."></input-help>
                                    </b-form-group>
                                </b-col>
                                <b-col lg="6">
                                    <b-form-group label="Email Subject" label-for="decommission_email_subject">
                                        <b-form-input
                                            v-model="form.decommission_email_subject"
                                            id="decommission_email_subject"
                                            name="decommission_email_subject"
                                            type="text"
                                        ></b-form-input>
                                        <input-help :form="form" field="decommission_email_subject" text="The subject of the email."></input-help>
                                    </b-form-group>
                                    <b-form-group label="Email Body" label-for="decommission_email_body">
                                        <b-textarea
                                            v-model="form.decommission_email_body"
                                            id="decommission_email_body"
                                            name="decommission_email_body"
                                            rows="4"
                                        ></b-textarea>
                                        <input-help :form="form" field="decommission_email_body" text="The body of the email."></input-help>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                          <b-row>
                            <b-col lg="12">
                              <p class="h5 mt-4">Communication Settings Preferences</p>
                              <hr>
                            </b-col>
                            <b-row>
                              <b-col lg="6">
                                <h3>Enrollment and Association Settings</h3>
                                <b-form-group label="Automatically send an email upon Claimant being enrolled" label-for="contact_preferences_claimant_enrolled">
                                  <b-select class="form-control" name="contact_preferences_claimant_enrolled" id="contact_preferences_claimant_enrolled" v-model="form.contact_preferences_claimant_enrolled">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                  </b-select>
                                  <input-help :form="form" field="contact_preferences_claimant_enrolled" text="This will send an email automatically to the email address below when the claimant is enrolled."></input-help>
                                </b-form-group>
                                <b-form-group label="Automatically send an email upon a Caregiver being enrolled" label-for="contact_preferences_caregiver_enrolled">
                                  <b-select name="contact_preferences_caregiver_enrolled" id="contact_preferences_caregiver_enrolled" v-model="form.contact_preferences_caregiver_enrolled">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                  </b-select>
                                  <input-help :form="form" field="contact_preferences_caregiver_enrolled" text="This will send an email automatically to the email address below when the caregiver is enrolled."></input-help>
                                </b-form-group>
                                <b-form-group label="Do the Claimant and Caregiver need to be associated before an email is sent" label-for="contact_preferences_association_required">
                                  <b-select name="contact_preferences_association_required" id="contact_preferences_association_required" v-model="form.contact_preferences_association_required">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                  </b-select>
                                  <input-help :form="form" field="contact_preferences_association_required" text="Require the association to exist before sending the email."></input-help>
                                </b-form-group>
                              </b-col>
                              <b-col lg="6">
                                <h3>Disassocation and Deactivation Settings</h3>
                                <b-form-group label="Automatically send email upon a Claimant deactivation" label-for="contact_preferences_claimant_deactivation">
                                  <b-select name="contact_preferences_claimant_deactivation" id="contact_preferences_claimant_deactivation" v-model="form.contact_preferences_claimant_deactivation">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                  </b-select>
                                  <input-help :form="form" field="contact_preferences_claimant_deactivation" text="Send and email to the address below when a claimant is deactivated."></input-help>
                                </b-form-group>
                                <b-form-group label="Include deactivation reason" label-for="contact_preferences_include_deactivation_reason">
                                  <b-select name="contact_preferences_include_deactivation_reason" id="contact_preferences_include_deactivation_reason" v-model="form.contact_preferences_include_deactivation_reason">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                  </b-select>
                                  <input-help :form="form" field="contact_preferences_include_deactivation_reason" text="Include the deactivation reason."></input-help>
                                </b-form-group>
                                <b-form-group label="Automatically send an email upon caregiver being disassociated from the claimant " label-for="contact_preferences_send_on_disassociation">
                                  <b-select name="contact_preferences_send_on_disassociation" id="contact_preferences_send_on_disassociation" v-model="form.contact_preferences_send_on_disassociation">
                                    <option value="0">No</option>
                                    <option value="1">Yes</option>
                                  </b-select>
                                  <input-help :form="form" field="contact_preferences_send_on_disassociation" text="Send the email when a disassociation occurs."></input-help>
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col lg="12">
                                <b-form-group label="Notification Email" label-for="contact_preferences_email">
                                  <b-form-input
                                      v-model="form.contact_preferences_email"
                                      id="contact_preferences_email"
                                      name="contact_preferences_email"
                                      type="text"
                                  ></b-form-input>
                                  <input-help :form="form" field="contact_preferences_email" text="The email address to send the email to for enrollement, activation and association events."></input-help>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-row>
                            <div class="d-flex">
                                <div>
                                  <spinner-button
                                      variant="success"
                                      size="lg"
                                      type="submit"
                                      :disabled="busy"
                                      :busy="busy"
                                  >{{ verb | capitalize }} Carrier</spinner-button>
<!--                                    <b-button variant="success" size="lg" type="submit" :disabled="busy"></b-button>-->
                                </div>
                                <div v-if="isEditing" class="ml-auto">
                                    <b-button v-if="active" variant="danger" size="lg" @click="toggleActive()" :disabled="busy">De-activate Carrier</b-button>
                                    <b-button v-else variant="danger" size="lg" @click="toggleActive()" :disabled="busy">Activate Carrier</b-button>
                                </div>
                            </div>
                        </form>
                    </b-card>
                </b-tab>
                <b-tab title="Managers" class="mt-4" :disabled=" !isEditing ">

                    <b-card header="Carrier Managers"
                        header-bg-variant="info"
                        header-text-variant="white">

                        <carrier-manager-list :carrier=" carrier " v-if=" isEditing "></carrier-manager-list>
                    </b-card>
                </b-tab>
            </b-tabs>
        </b-col>
    </b-row>
</template>

<script>
    import FormatsDates from '../../mixins/FormatsDates';
    import SpinnerButton from '../ui/SpinnerButton'

    let batch_schedule_times_list = [];
    for (let i = 0; i < 24; i++) {
        let time = i.toString();
        if (time.length < 2) {
            time = '0' + time;
        }
        batch_schedule_times_list.push(`${time}:00`);
    }

    export default {
      components: {SpinnerButton},
      props: {
            carrier: {
                type: Object,
                default: () => { return {} },
            },
            submissionTimes: {
              type: Array,
              default: () => ['06:00'],
            }
        },

        mixins: [ FormatsDates ],

        data() {
            return {
                busy: false,
                active: !!this.carrier.active,
                form: new Form({}),
                batch_schedule_days_list: [
                    {name: 'Sunday', value: 64},
                    {name: 'Monday', value: 32},
                    {name: 'Tuesday', value: 16},
                    {name: 'Wednesday', value: 8},
                    {name: 'Thursday', value: 4},
                    {name: 'Friday', value: 2},
                    {name: 'Saturday', value: 1}
                ],
                batch_schedule_days: [],
                batch_schedule_times_list,
                invoice_batch_file_name_vars: {
                    ID: 'Transmission ID',
                    DATE: 'Date of transmission (YYYYMMDD)',
                    TIME: 'Time of transmission (HHMMSS)',
                    DATETIME: 'Date and time of transmission (YYYYMMDDTHHMMSS)',
                    YEAR: 'Year of transmission (YYYY)',
                    MONTH: 'Month of transmission (MM)',
                    DAY: 'Day of transmission (DD)',
                    HOUR: 'Hour of transmission (HH)',
                    MINUTE: 'Minute of transmission (MM)',
                    SECOND: 'Minute of transmission (SS)'
                },
                invoice_attachment_name_vars: {
                    ID: 'Invoice ID - *Batch Only*',
                    NAME: 'Name of invoice ({Policy/Claim ID}-{Claimant Invoice Number}) - *Batch Only*'
                },
                email_subject_vars: {
                    INVOICE_NO: 'Invoice ID - *Non Batch Only*',
                    POLICY_NUMBER: 'Claimants policy number - *Non Batch Only*',
                    MEMBER_ID: 'Claimants member ID - *Non Batch Only*',
                    TRANSMISSION_ID: 'Transmission ID - *Batch Only*',
                    TRANSMISSION_DATE: 'Transmission date (YYYYMMDD) - *Batch Only*',
                    TRANSMISSION_TIME: 'Transmission time (HHMMSS) - *Batch Only*'
                },
                email_body_vars: {
                    INVOICE_LIST: 'List of claimant names with invoice name ({Claimant First Name} {Claimant Last Name}: {Invoice Name}) - *Batch Only*',
                    INVOICE_COUNT: 'Count of invoices - *Batch Only*'
                }
            }
        },

        computed: {
          hasPaymentDay() {
            const paymentDayEnabled = parseInt(this.form.client_payment_day_enabled);
            const invoiceAutoTransmit = parseInt(this.form.invoice_auto_transmit);
            const batchInvoiceEnabled = parseInt(this.form.batch_invoices);
            return paymentDayEnabled === 1 && (batchInvoiceEnabled === 1 || invoiceAutoTransmit === 1);
          },
          submissionDays() {
            return [
              'mondays',
              'tuesdays',
              'wednesdays',
              'thursdays',
              'fridays',
              'saturdays',
              'sundays',
              'daily',
            ];
          },
            isEditing() {
                return !!this.carrier.id;
            },
            verb() {
                if (this.carrier.id) {
                    return 'save';
                }
                return 'create';
            },
            title() {
                return this.carrier.id ? this.carrier.name : 'Add New Carrier';
            }
        },

        methods: {
            updateHospitalStayFlags(val) {
                this.form.hospital_stays_enabled = val;
                this.form.hospital_stays_enhanced_flow = val;
            },
            async submit() {
                const r = confirm(`You have changed configuration settings for ${this.carrier.name}. Are you sure?`)
                if (!r) {
                  return;
                }
                try {
                  this.busy = true;
                  let method = this.isEditing ? 'patch' : 'post';
                  let url = this.isEditing ? `/business/carriers/${this.carrier.id}` : `/business/carriers`;
                  this.form.batch_schedule_days = this.batch_schedule_days.reduce((carry, value) => (carry | value), 0);
                  const {data} = await this.form.submit(method, url)
                  if (this.isEditing && typeof data.data.active !== 'undefined') {
                      this.form = this.createForm(data.data);
                      this.active = data.data.active;
                  }
                } finally {
                  this.busy = false
                }
            },

            checkIfCNAGroup() {
                if (this.carrier.initials === "CNA Group") {
                    return true
                }
                return false
            },

            checkIfCalPERS() {
                if (this.carrier.initials === "CalPERS") {
                    return true
                }
                return false
            },

            toggleActive() {
                if (! this.isEditing) {
                    return;
                }

                this.busy = true;
                let verb = this.active ? 'deactivate' : 'activate';
                axios.patch(`/business/carriers/${this.carrier.id}/${verb}`)
                    .then( ({ data }) => {
                        this.form = this.createForm(data.data);
                        this.active = data.data.active;
                    })
                    .catch(e => {})
                    .finally(() => {
                        this.busy = false;
                    });
            },

            createForm(defaults = {}) {
                return new Form({
                    initials: defaults.initials ? defaults.initials : '',
                    name: defaults.name ? defaults.name : '',
                    import_match: defaults.import_match ? defaults.import_match : '',
                    phone: defaults.phone ? defaults.phone : '',
                    logo_filename: defaults.logo_filename ? defaults.logo_filename : '',
                    terms_client: defaults.terms_client ? defaults.terms_client : '',
                    terms_caregiver: defaults.terms_caregiver ? defaults.terms_caregiver : '',
                    warning_language: defaults.warning_language ? defaults.warning_language : '',
                    evv_radius: defaults.evv_radius ? defaults.evv_radius : 300,
                    auto_enroll_claimants: defaults.auto_enroll_claimants ? defaults.auto_enroll_claimants : 0,
                    use_enrollment_queue: defaults.use_enrollment_queue ? defaults.use_enrollment_queue : 0,
                    invoice_transmission_type: defaults.invoice_transmission_type ? defaults.invoice_transmission_type : '',
                    invoice_attachment_type: defaults.invoice_attachment_type ? defaults.invoice_attachment_type : '',
                    invoice_attachment_name: defaults.invoice_attachment_name ? defaults.invoice_attachment_name : '',
                    invoice_ftp_host: defaults.invoice_ftp_host ? defaults.invoice_ftp_host : '',
                    invoice_ftp_username: defaults.invoice_ftp_username ? defaults.invoice_ftp_username : '',
                    invoice_ftp_password: defaults.invoice_ftp_password ? '********' : '',
                    invoice_ftp_path: defaults.invoice_ftp_path ? defaults.invoice_ftp_path : '',
                    invoice_email_to: defaults.invoice_email_to ? defaults.invoice_email_to : '',
                    invoice_email_from: defaults.invoice_email_from ? defaults.invoice_email_from : '',
                    invoice_email_subject: defaults.invoice_email_subject ? defaults.invoice_email_subject : '',
                    invoice_email_body: defaults.invoice_email_body ? defaults.invoice_email_body : '',
                    invoice_auto_transmit: defaults.invoice_auto_transmit == true ? 1 : 0,
                    invoice_policy_name: defaults.invoice_policy_name ? defaults.invoice_policy_name : 'Policy Name',
                    invoice_requires_approval: defaults.invoice_requires_approval ? 1 : 0,
                    invoice_policy_field: defaults.invoice_policy_field ? defaults.invoice_policy_field : 'policy_number',
                    enabled_user_data_pull: defaults.enabled_user_data_pull ? defaults.enabled_user_data_pull : 0,
                    is_tpa: defaults.is_tpa ? defaults.is_tpa : 0,
                    decommission_transmission_type: defaults.decommission_transmission_type ? defaults.decommission_transmission_type : '',
                    decommission_attachment_type: defaults.decommission_attachment_type ? defaults.decommission_attachment_type : '',
                    decommission_attachment_name: defaults.decommission_attachment_name ? defaults.decommission_attachment_name : '',
                    decommission_ftp_host: defaults.decommission_ftp_host ? defaults.decommission_ftp_host : '',
                    decommission_ftp_username: defaults.decommission_ftp_username ? defaults.decommission_ftp_username : '',
                    decommission_ftp_password: defaults.decommission_ftp_password ? '********' : '',
                    decommission_ftp_path: defaults.decommission_ftp_path ? defaults.decommission_ftp_path : '',
                    decommission_email_to: defaults.decommission_email_to ? defaults.decommission_email_to : '',
                    decommission_email_from: defaults.decommission_email_from ? defaults.decommission_email_from : '',
                    decommission_email_subject: defaults.decommission_email_subject ? defaults.decommission_email_subject : '',
                    decommission_email_body: defaults.decommission_email_body ? defaults.decommission_email_body : '',

                    parent_carrier_id: defaults.parent_carrier_id ? defaults.parent_carrier_id : '',

                    custom_enrollment_codes: defaults.custom_enrollment_codes ? defaults.custom_enrollment_codes : false,
                    client_enrollment_code: defaults.client_enrollment_code ? defaults.client_enrollment_code : '',
                    caregiver_enrollment_code: defaults.caregiver_enrollment_code ? defaults.caregiver_enrollment_code: '',

                    batch_invoices : defaults.batch_invoices ? 1 : 0,
                    batch_invoices_csv : defaults.batch_invoices_csv ? 1 : 0,
                    batch_invoices_txt : defaults.batch_invoices_txt ? 1 : 0,
                    batch_filename : defaults.batch_filename ? defaults.batch_filename: '',
                    batch_directory : defaults.batch_directory ? defaults.batch_directory: '',
                    batch_csv_filename : defaults.batch_csv_filename ? defaults.batch_csv_filename: '',
                    batch_csv_directory : defaults.batch_csv_directory ? defaults.batch_csv_directory: '',
                    batch_txt_filename : defaults.batch_txt_filename ? defaults.batch_txt_filename: '',
                    batch_txt_directory : defaults.batch_txt_directory ? defaults.batch_txt_directory: '',
                    batch_send_notification : defaults.batch_send_notification ? 1 : 0,
                    batch_schedule_days: undefined,
                    batch_schedule_time: defaults.batch_schedule_time ? defaults.batch_schedule_time : '',
                    grayscale_invoices : defaults.grayscale_invoices ? '1' : '0',
                    invoice_submission_time : defaults.invoice_submission_time ? defaults.invoice_submission_time: '06:00',
                    invoice_submission_day : defaults.invoice_submission_day ? defaults.invoice_submission_day: 'mondays',
                    client_payment_day_enabled : defaults.client_payment_day_enabled ? '1' : '0',
                    invoice_delta : defaults.invoice_delta ? defaults.invoice_delta : '0',
                    hospital_stays_enabled : defaults.hospital_stays_enabled ? '1' : '0',
                    hospital_stays_enhanced_flow : defaults.hospital_stays_enhanced_flow ? '1' : '0',
                    hospital_stays_recipients : defaults.hospital_stays_recipients ? defaults.hospital_stays_recipients.join(',') : '',
                    hospital_stays_email : defaults.hospital_stays_email ? defaults.hospital_stays_email : '',
                    hospital_stays_subject : defaults.hospital_stays_subject ? defaults.hospital_stays_subject : '',
                    contact_preferences_email : defaults.contact_preferences_email ? defaults.contact_preferences_email : '',
                    contact_preferences_claimant_enrolled : defaults.contact_preferences_claimant_enrolled ? defaults.contact_preferences_claimant_enrolled : '0',
                    contact_preferences_caregiver_enrolled : defaults.contact_preferences_caregiver_enrolled ? defaults.contact_preferences_caregiver_enrolled  : '0',
                    contact_preferences_association_required : defaults.contact_preferences_association_required ? defaults.contact_preferences_association_required  : '0',
                    contact_preferences_claimant_deactivation : defaults.contact_preferences_claimant_deactivation ? defaults.contact_preferences_claimant_deactivation  : '0',
                    contact_preferences_include_deactivation_reason : defaults.contact_preferences_include_deactivation_reason ? defaults.contact_preferences_include_deactivation_reason : '0',
                    contact_preferences_send_on_disassociation : defaults.contact_preferences_send_on_disassociation ? defaults.contact_preferences_send_on_disassociation : '0',

                })
            },
        },

        mounted() {
            this.form = this.createForm(this.carrier);

            if (this.carrier.batch_schedule_days) {
                // extract selected days from bit flag days value
                let selected_days = [];
                for (let {value} of this.batch_schedule_days_list) {
                    if ((this.carrier.batch_schedule_days & value) === 0) {
                        continue;
                    }
                    selected_days.push(value);
                }
                this.batch_schedule_days = selected_days;
            }
        },
        watch: {
            'form.client_payment_day_enabled': function(newVal, oldVal) {

              if (typeof this.form.invoice_auto_transmit === 'undefined') {
                return;
              }

              if (newVal == '1' && !this.form.invoice_auto_transmit) {
                this.form.invoice_auto_transmit = '1';
              }
            }
        },
    }
</script>
